import OfferActionsDetail from './styled';

export default OfferActionsDetail;
